module.exports = __webpack_public_path__ + "static/media/preset-fast.55f6a2e5.gif";